module.exports = __webpack_public_path__ + "img/vote-8.81183da6.png";